import { IdentityDocumentSubTypesEnum } from '../../../lib/models/enroll-requests';

import { EnrollDocumentDetailsForm } from './EnrollDocumentDetails.types';

export const EnrollDocumentDetailsFormInit: EnrollDocumentDetailsForm = {
  documentNumber: '',
  documentType: IdentityDocumentSubTypesEnum.identityCard,
  dateOfExpiring: '',
};
